import React, { useState, useEffect } from 'react';
import { 
    Dialog,
    DialogContent,
    DialogTitle,  
    Alert,
    AlertTitle
} from "@mui/material";
import outWardService from "../../../../services/outWardService";
import invoiceService from '../../../../services/invoicesService';
import { useSelector } from 'react-redux';
import {
    Backdrop,
    Box,
    CircularProgress,
    Modal,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Paper,
    Typography,
    Pagination,
    Stack,
    TextField,
    Button,
    Select,
    MenuItem,
    Chip,
    Divider
} from "@mui/material";
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import PendingIcon from '@mui/icons-material/Pending';
import InfoIcon from '@mui/icons-material/Info';
import ReceiptIcon from '@mui/icons-material/Receipt';

// Özel stiller tanımlama
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
    borderRadius: '12px',
    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    border: '1px solid rgba(224, 224, 224, 0.5)',
}));

const StyledTable = styled(Table)(({ theme }) => ({
    minWidth: 550,
}));

const StyledTableHeadCell = styled(TableCell)(({ theme }) => ({
    backgroundColor: '#2196f3', 
    color: 'white',
    fontWeight: 600,
    fontSize: '0.875rem',
    padding: '16px',
    '&:first-of-type': {
        borderTopLeftRadius: '8px',
    },
    '&:last-of-type': {
        borderTopRightRadius: '8px',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        transition: 'background-color 0.2s ease',
    }, 
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: '16px',
    fontSize: '0.875rem',
}));
 
 
export const InvoiceStatusPopUpModel = ({ openDialog, handleCloseDialog, data }) => {
     const [loading, setLoading] = useState(false); 
    const [status, setStatus] = useState({});
    const [invoiceStatusList, setInvoiceStatusList] = useState(null);
     

    const getInvoiceStatus = async () => {
        setLoading(true);
        if (loading) {
            return;
        }
        try {
            var statusList = await invoiceService.fetchInvoicesStatus(data.id);
            setInvoiceStatusList(statusList?.data?.data)
            setStatus({
                success: true,
                message: 'Fatura durum getirme işlemi başarılı'
            });
        } catch (error) {
            console.log(error)
            setStatus({
                success: false,
                message: error.response?.data?.Message || 'Fatura durum getirme işlemi başarısız oldu'
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!openDialog) {
            setLoading(false);
        }
        else {
            getInvoiceStatus();
        }
    }, [openDialog]);

    return (
        <Box>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        overflow: 'hidden'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1
                    }}
                >
                    <ReceiptIcon />
                    Fatura Aktarma Durumu
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: 200,
                        p: 3,
                        maxHeight: '80vh',   
                        overflow: 'hidden'  
                    }}
                >
                    {loading ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <CircularProgress sx={{ mb: 2 }} />
                            <Typography variant="body1">
                                Fatura bilgisi getiriliyor, lütfen bekleyin...
                            </Typography>
                        </Box>
                    ) : status.success === false ? (
                        <Alert
                            severity={status.success ? "success" : "error"}
                            sx={{ width: '100%', borderRadius: '8px' }}
                            variant="filled"
                        >
                            <AlertTitle>
                                {status.success ? "Başarılı" : "Hata"}
                            </AlertTitle>
                            {status.message}
                        </Alert>
                    ) : (
                        <>
                            {invoiceStatusList && invoiceStatusList.length > 0 ? (
                                <>
                                    <Box sx={{ width: '100%', mb: 2 }}>
                                   
                                        <Divider />
                                    </Box>
                                    <Box sx={{ width: '100%', maxHeight: '60vh', overflow: 'auto' }}>
                                        <StyledTableContainer component={Paper}>
                                            <StyledTable aria-label="fatura durum tablosu" stickyHeader>
                                                <TableHead>
                                                    <TableRow> 
                                                        <StyledTableHeadCell>Açıklama</StyledTableHeadCell>
                                                        <StyledTableHeadCell>Tarih</StyledTableHeadCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {invoiceStatusList.map((item, index) => (
                                                        <StyledTableRow key={item.id || index}> 
                                                            <StyledTableCell>{item.userDescription || "Fatura işleniyor..."}</StyledTableCell>
                                                            <StyledTableCell>
                                                                {item.createDate.replace('T', ' ').substring(0, 19) || new Date().toISOString().replace('T', ' ').substring(0, 19)}
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    ))}
                                                </TableBody>
                                            </StyledTable>
                                        </StyledTableContainer>
                                    </Box>
                                </>
                            ) : (
                                <Alert
                                    severity="info"
                                    sx={{ width: '100%', borderRadius: '8px' }}
                                >
                                    <AlertTitle>Bilgi</AlertTitle>
                                    Gösterilecek fatura durumu bulunamadı.
                                </Alert>
                            )}
                                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', width: '100%' }}>
                                <Button 
                                    variant="contained" 
                                    onClick={handleCloseDialog}
                                    sx={{ 
                                        borderRadius: '4px',
                                        bgcolor: '#2196f3', 
                                        color: 'white',
                                        fontWeight: 'bold',
                                        px: 4,
                                        '&:hover': {
                                            bgcolor: '#1976d2'
                                        }
                                    }}
                                >
                                    Kapat
                                </Button>
                            </Box>
                        </>
                    )}
                </DialogContent>
            </Dialog>
        </Box>
    );
}

export default InvoiceStatusPopUpModel;